import React, { FunctionComponent, Component, useEffect, useState, Fragment } from 'react';
import { Row, Col, Card, Modal, Form, Button  } from 'react-bootstrap';
import ButtonSubmit from '../basicComponents/buttonSubmit';
import ObexAlert from '../basicComponents/ObexAlerts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

type ModalProps = {
  showModal: boolean,
  onCloseModal: () => void,
  handleSubmit: (e) => void,
  loading: boolean,
  error: string,
  success: string,
  name_to_check: string,
  title_to_show: string
}

const ConfirmDeleteProjectModal:FunctionComponent<ModalProps> = (props:ModalProps) => {
  
  const { showModal, onCloseModal, handleSubmit, loading, error, success, name_to_check, title_to_show } = props;
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [valor_a_comparar, setValorAComparar] = useState('');

  const CheckEntry = (value) =>{

    if (value==name_to_check) setSubmitDisabled(false)

  }

  return(
    <Modal dialogClassName="cloudModal"
      show={showModal} 
      onHide={onCloseModal}
      animation={false}
      centered
      scrollable
      container={document.getElementById('dashboardWrapper')}>
     
      <Modal.Header closeButton className="cloudModal modal-header addons-title">
        <Modal.Title className="text-start w-100 mx-auto addons-title">
          <Row>
            <Col md="12" className="addons-title">
              <span className='pl-3'>Confirm delete {title_to_show}</span>
            </Col>
          </Row>
        </Modal.Title>
      </Modal.Header>
      
      <div className="border-top border-black"></div>
      <Modal.Body  className="pt-0 text-start">
        <Row>
          <Col md="12" className="text-start cld_border_txt">
           <Row >
            <div className='pl-4 pr-4 text-start  mx-auto'>If there are any associated staging projects, they will also be permanently deleted. To proceed, please type '{name_to_check}' to confirm.</div>
            </Row>
            </Col>
          </Row>

         
            <Form>

            <Form.Row>
            <Col md="6" className="mt-4 text-start pb-3">
              <input type="text"  className="form-control text-start" name="name" style={{ width: '100%' }} 
              onChange={(e) => {
                const { value } = e.target;
                CheckEntry(value)
              }}
              />
              </Col>
              <Col md="6" className="mt-4 pb-3">
              <Button
                    //handleSubmit={handleSubmit}
                    disabled={submitDisabled}
                   onClick={handleSubmit}
                   className="customButton-blue  customButton btn-right"
                   >Confirm Delete</Button>
              </Col>
              </Form.Row>
              
             
              <Row>
                <Col>
                  <ObexAlert type='error' msg={error}/>
                </Col>
              </Row>
            </Form>
          

      </Modal.Body>
    </Modal>
  )
}

export default ConfirmDeleteProjectModal;